'use strict';
import angular from 'angular';

angular.module('nightlystatus.services', [])
    .service('NightlyStatusService', NightlyStatusService)
    .service('NightlyStatusFactory', NightlyStatusFactory);

NightlyStatusService.$inject = ['NightlyStatusFactory', '$q'];
function NightlyStatusService (NightlyStatusFactory, $q) {
    //service object
    var service = {};

    //declare your server vars here
    service.tasks = null;

    service.timedTasksForIdAndMonth = function(clusterId, month, year) {
        var deferred = $q.defer();
        var params = {
            'clusterId': clusterId,
            'month': month,
            'year': year
        };

        NightlyStatusFactory.timedTasksForIdAndMonth().get(params).$promise.then(function(data) {
            if (data.slotBookings == null) {
                service.tasks = [];
            } else {
                service.tasks = data.slots;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.timedTasks = function(date) {
        var deferred = $q.defer();
        if(date){
            var dateObj = new Date(date);
        }
        var params = {
            'month': date ? dateObj.getMonth()+1 : date,
            'year': date ? dateObj.getFullYear() : date
        };
        NightlyStatusFactory.timedTasks().get(params).$promise.then(function(data){
            deferred.resolve(data.logs);
        }, function(response){
            deferred.reject();
        });
        return deferred.promise;
    };

    service.logsForDay = function(date) {
        var deferred = $q.defer();
        if(!date){
            deferred.resolve([]);
            deferred.promise
        }
        var params = {
            'date': date,
        };
        NightlyStatusFactory.logsForDay().get(params).$promise.then(function(data){
            deferred.resolve(data.logs);
        }, function(response){
            deferred.reject();
        });
        return deferred.promise;
    };

    return service;
}

NightlyStatusFactory.$inject = ['$resource', 'AppConfig'];
function NightlyStatusFactory ($resource, AppConfig) {
    var factory = {};

    factory.timedTasksForIdAndMonth = function(clusterId, month, year) {
        return $resource(AppConfig.IO_API_URL + 'timedTasksForIdAndMonth', {
            'clusterId': clusterId,
            'month': month,
            'year':year
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.timedTasks = function() {
        return $resource(AppConfig.IO_API_URL + 'jobs/logsForMonth', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        })
    };

    factory.logsForDay = function() {
        return $resource(AppConfig.IO_API_URL + 'jobs/log', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        })
    };

    return factory;
}